import { useRef } from 'react';

import PropTypes from 'prop-types';

const KEYBOARD_STEP = 16;

const headerWidth = (handle) => handle.parentElement.getBoundingClientRect().width;

const ColumnResizeHandle = ({ onResize, onResizeEnd, onReset }) => {
	const drag = useRef(null);

	const widthAt = (e) => drag.current.startWidth + e.clientX - drag.current.startX;

	return (
		<span
			role="separator"
			aria-orientation="vertical"
			aria-label="Spaltenbreite ändern"
			tabIndex={0}
			title="Ziehen zum Ändern der Breite, Doppelklick zum Zurücksetzen"
			className="group/resize absolute inset-y-0 -right-[6.5px] z-10 flex w-3 cursor-col-resize touch-none justify-center outline-none"
			onPointerDown={(e) => {
				e.preventDefault();
				e.currentTarget.setPointerCapture(e.pointerId);
				drag.current = { startX: e.clientX, startWidth: headerWidth(e.currentTarget) };
			}}
			onPointerMove={(e) => drag.current && onResize(widthAt(e))}
			onPointerUp={(e) => {
				if (!drag.current) return;
				onResizeEnd(widthAt(e));
				drag.current = null;
			}}
			onPointerCancel={() => {
				drag.current = null;
			}}
			onDoubleClick={onReset}
			onClick={(e) => e.stopPropagation()}
			onKeyDown={(e) => {
				const direction = { ArrowLeft: -1, ArrowRight: 1 }[e.key];
				if (!direction) return;
				e.preventDefault();
				onResizeEnd(headerWidth(e.currentTarget) + direction * KEYBOARD_STEP);
			}}
		>
			<span className="h-full w-0.5 bg-transparent transition-colors group-hover/resize:bg-primary-400 group-focus-visible/resize:bg-primary-400 group-active/resize:bg-primary-600" />
		</span>
	);
};

ColumnResizeHandle.propTypes = {
	onResize: PropTypes.func.isRequired,
	onResizeEnd: PropTypes.func.isRequired,
	onReset: PropTypes.func.isRequired,
};

export default ColumnResizeHandle;
